<template>
  <div class="audience-volume-graph-chart">
    <v-chart
      class="w-chart--audience-volume"
      :option="chartData"
      style="width: 404px; height: 300px;"
    />
  </div>
</template>

<script>
export default {
    name: 'AudienceVolumeChart',

    props: {
        audienceVolumeData: {
            type: Array,
            required: true
        },
        audienceId: {
            type: Number,
            required: true
        },
    },

    data() {
        return {
            options: {
                grid: {
                    left: 65,
                    right: 20
                },
                yAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },
                    nameTextStyle: {
                        color: '#4d4d4d'
                    },
                    splitLine: {
                        show: false
                    },
                    name: 'Volume',
                    nameLocation: 'end',
                    // nameRotate: 90,
                    nameGap: 15
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function(params) {
                        params = params[0]
                        const date = params.name
                        const volume = params.value

                        return 'Date: ' + date + ' | Volume: ' + volume
                    },
                    axisPointer: {
                        label: {
                            show: true
                        }
                    }
                },
            }
        }
    },

    computed: {
        profile() {
            return this.selectedProfile === 'nonEmpty' ? 'nep' : 'ap'
        },
        dateList() {
            return this.audienceVolumeData.map(item => {
                return item[0]
            })
        },
        volumeList() {
            return this.audienceVolumeData.map(item => {
                return item[1]
            })
        },
        chartData() {
            return {
                ...this.options,
                xAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },
                    axisTick: {
                        lineStyle: {
                            color: '#4d4d4d'
                        }
                    },

                    nameTextStyle: {
                        color: '#4d4d4d'
                    },
                    name: 'Date',
                    nameLocation: 'center',
                    nameGap: 35,

                    boundaryGap: false,
                    data: this.dateList,
                    splitLine: {
                        show: false
                    }
                },
                series: [
                    {
                        type: 'line',
                        symbolSize: 5,
                        data: this.volumeList ?? [],
                        sampling: 'average',
                        lineStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#f12711' // color at 0% position
                                    },
                                    {
                                        offset: 1,
                                        color: '#f5af19' // color at 100% position
                                    }
                                ],
                                global: false // false by default
                            },
                            width: 3
                        }
                    }
                ]
            }
        }
    },
}
</script>
